// Format a duration stored in minutes as a friendly hours label, e.g. 90 -> "1.5 hr", 60 -> "1 hr".
export function formatDuration(minutes) {
  const h = Math.round((Number(minutes || 0) / 60) * 100) / 100;
  return `${h} ${h === 1 ? "hr" : "hrs"}`;
}

// Resolve a stored media reference to a loadable URL. Relative /api/... paths are prefixed with
// the backend URL; absolute http(s) URLs (e.g. legacy Unsplash links) are returned as-is.
export function mediaUrl(u) {
  if (!u) return u;
  if (/^https?:\/\//i.test(u)) return u;
  return `${process.env.REACT_APP_BACKEND_URL}${u}`;
}
